module.exports = __webpack_public_path__ + "static/media/contact-info.35dc77dd.gif";